import { Link } from "react-router-dom";
import { RULESET_LIST } from "../content/rules";

export default function RulesPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold">Rules</h1>
        <Link to="/" className="text-sm text-white/60 hover:text-white">
          Back home
        </Link>
      </div>

      <p className="text-white/70 mb-8">
        Setback (also called Pitch, Auction Pitch, or High-Low-Jack) is a
        partnership trick-taking game. This site supports two rulesets —
        pick whichever matches how your group plays.
      </p>

      <div className="space-y-10">
        {RULESET_LIST.map(r => (
          <section
            key={r.id}
            className="bg-white/5 border border-white/10 rounded-2xl p-6"
          >
            <div className="flex items-baseline justify-between gap-4 mb-1">
              <h2 className="text-2xl font-bold">{r.label}</h2>
              <span className="text-xs uppercase tracking-wide text-white/40">
                id: {r.id}
              </span>
            </div>
            <p className="text-white/60 text-sm mb-6">{r.summary}</p>

            <div className="space-y-5">
              {r.sections.map((s, i) => (
                <div key={i}>
                  <h3 className="text-lg font-semibold mb-2">{s.heading}</h3>
                  <div className="space-y-2 text-white/80 text-sm leading-relaxed">
                    {s.body.map((para, j) => (
                      <p key={j} className="whitespace-pre-wrap">{para}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-10 text-xs text-white/40">
        Found a rule that disagrees with how your group plays? Let us know
        and we can add a variant.
      </div>
    </div>
  );
}
